import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/Services/auth.service';
import { TokenService } from 'src/app/Services/token.service';
import { UserService } from 'src/app/Services/user.service';
import * as shajs from 'sha.js';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})

export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  loggedIn: any;
  role: any;
  payload: any;
  user: any;

  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    private auth: AuthService,
    private token: TokenService,
    private router: Router,
    private userService: UserService) {
    this.resetPasswordForm = this.fb.group({
      current_password: [
        null,
        Validators.compose([Validators.required]),
      ],
      new_password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(
            '(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$'
          ),
        ]),
      ],
      new_password_confirmation: [
        null,
        Validators.compose([
          Validators.required
        ]),
      ],
    });
  }

  ngOnInit(): void {
    this.userService.getUser({}).then(user => {
      this.user = user;
    });
  }

  goToHome(){
    this.payload = this.token.payload(localStorage.getItem('token'));

    const role = this.payload['role_id'];
    switch (role) {
      case 1: {
        this.router.navigateByUrl('/admin/user-management');
        break;
      }
      case 2: {
        this.router.navigateByUrl('/super-admin');
        break;
      }
      case 3: {
        this.router.navigateByUrl('/expert');
        break;
      }
      case 4: {
        this.router.navigateByUrl('/moderator');
        break;
      }
      case 5: {
        this.router.navigateByUrl('/institute');
        break;
      }
      case 6: {
        this.router.navigateByUrl('/student/basic-details');
        break;
      }
      // case 7: {
      //   this.router.navigateByUrl('/hod');
      //   break;
      // }
      case 8: {
        this.router.navigateByUrl('/faculty');
        break;
      }
      case 9: {
        this.router.navigateByUrl('/finance');
        break;
      }
      case 10: {
        this.router.navigateByUrl('/nodal-officer');
        break;
      }
      case 11: {
        this.router.navigateByUrl('/consultant');
        break;
      }
      default: {
        this.auth.logout();
      }
    }
  }

  onSubmit(values) {
    if (this.resetPasswordForm.valid) {
      if (values['new_password'] == values['new_password_confirmation']) {

        if (values['current_password'] != values['new_password']) {

          const data = {
            current_password: shajs('sha512').update(this.resetPasswordForm.controls.current_password.value + btoa(this.user['email'])).digest('hex'),
            new_password: shajs('sha512').update(this.resetPasswordForm.controls.new_password.value + btoa(this.user['email'])).digest('hex'),
            new_password_confirmation: shajs('sha512').update(this.resetPasswordForm.controls.new_password_confirmation.value + btoa(this.user['email'])).digest('hex')
          }

          this.userService.resetPassword(data).subscribe(
            data => {
              if (data['type'] == 'Success') {
                this.toastr.success(data['message']);
                localStorage.clear();
                this.token.remove();
                this.auth.changeStatus(false);
                this.router.navigateByUrl('/login');
              } else {
                this.toastr.error(data['message']);
              }
            }
          )
        } else {
          this.toastr.error("Current password and new password cannot be the same!");
        }

      } else {
        this.toastr.error("New password and confirm new password don't match!");
        return;
      }
    } else {
      this.toastr.error("Please enter valid values!");
      return;
    }
  }

    logout(event: MouseEvent) {
      event.preventDefault();
      this.token.remove();
      this.auth.changeStatus(false);
      // this.router.navigateByUrl('/login');
      window.location.replace('/login');
  }

}
